<template lang='pug'>
form
  .row
    table.custom-tb-stregth
      tr
        td.text-center(v-for='item in limitSubject()').custom-td-strength
          img.img(:src='item.icon').custom-img-strength
          p.txt-strength {{item.name}}
      
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'

export default {
  props: {
    user: Object
  },
  methods: {
    limitSubject() {
      var count = 0
      var lst = []
      if (this.strengths) {
        for (var i = 0; i < this.strengths.length; i++) {
          count++
          if (count <= 3) lst.push(this.strengths[i])
        }
        return lst
      }
    }
  },
  data() {
    return {
      strengths: []
    }
  },
  apollo: {
    'strengths': {
      query: gql(graphql.GET_STRENGTH),
      variables() {
        return {
          user_id: this.$store.getters.user
        }
      },
      update: data => {
        var lst = []
        for (var i = 0; i < data.subject_user.length; i++) {
          lst.push(data.subject_user[i].subject)
        }
        return lst
      }
    }
  }
}
</script>

<style lang='scss'>
.custom-tb-stregth {
  width: 100%;
  border-collapse: separate;
  border-spacing: 10px 0px;
}
.custom-td-strength {
  width: 33% !important;
  padding: 10px 10px;
  background: #FAFAFA;
  box-shadow: 0px 1px 2px #00000029;
  border-radius: 3px;
  opacity: 1;
  // width: 109px !important;
  // height: 10px;
  // border: 1px solid;
}
.txt-strength {
  text-align:center;
  // font-family: Proxima Nova;
  color: #4B2D15;
  font-size: 13px;
  white-space: nowrap;
}
.custom-img-strength {
  width: 16px !important;
  height: 16px !important;
}

@media (max-width: 414px) {
  .custom-td-strength {
    width: 98px !important;
    // height: 62px;
  }
}
</style>



// WEBPACK FOOTER //
// Strength.vue?4ada26d6